'use client';

import { useImpersonationSession } from '@highlight-cp/hooks';
import { useSearchParams } from 'next/navigation';

export const FF_IMPERSONATOR_OVERRIDE_PARAM = 'ff_imp';

export interface FeatureFlagUserOverride {
  shouldUseImpersonator: boolean;
  impersonatorEmail: string | undefined;
}

export function useFeatureFlagImpersonatorOverride(): FeatureFlagUserOverride {
  const searchParams = useSearchParams();
  const session = useImpersonationSession();

  const isImpersonating = session?.impersonation === true;
  const hasOverrideParam = searchParams?.get(FF_IMPERSONATOR_OVERRIDE_PARAM) === 'true';

  return {
    shouldUseImpersonator: isImpersonating && hasOverrideParam,
    impersonatorEmail: session?.impersonator?.email,
  };
}
